"use client";

import { motion } from "motion/react";
import { Heart, Sparkles, Crown } from "lucide-react";
import Image from "next/image";

export function Preloader() {
  // { onComplete }: { onComplete: () => void }
  return (
    <motion.div
      key="preloader"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
      className="fixed inset-0 z-[9999999] bg-gradient-to-br from-[#fdfcfa] via-[#f5f1ec] to-[#e8dfd0] flex items-center justify-center"
      // onAnimationComplete={() => {
      //   setTimeout(
      //     // onComplete
      //     () => {},
      //     2500,
      //   );
      // }}
    >
      <div className="text-center">
        {/* Logo Animation */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-8"
        >
          <div className="relative h-24 w-64 mx-auto">
            <Image
              src="/imports/logo_2.png"
              alt="Sarasiruham Resort"
              fill
              className="object-contain"
            />
          </div>
        </motion.div>

        {/* Animated Icons */}
        <div className="flex items-center justify-center gap-8 mb-8">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <motion.div
              animate={{
                scale: [1, 1.2, 1],
                rotate: [0, 10, -10, 0],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Heart className="w-12 h-12 text-[#d4af37]" fill="#d4af37" />
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <motion.div
              animate={{
                scale: [1, 1.3, 1],
                rotate: [0, 360],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Sparkles className="w-12 h-12 text-[#5a6f3e]" />
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            <motion.div
              animate={{
                scale: [1, 1.2, 1],
                y: [0, -10, 0],
              }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Crown className="w-12 h-12 text-[#d4af37]" />
            </motion.div>
          </motion.div>
        </div>

        {/* Loading Text */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <h3
            className="text-2xl text-[#2a2520] mb-3"
            style={{
              fontFamily: "Cormorant Garamond, serif",
              fontWeight: 600,
              fontStyle: "italic",
            }}
          >
            Creating Unforgettable Moments
          </h3>
          <p
            className="text-[#2a2520]/70"
            style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
          >
            Luxury • Romance • Celebration
          </p>
        </motion.div>

        {/* Progress Bar */}
        <motion.div className="w-64 h-1 bg-[#5a6f3e]/20 rounded-full mx-auto mt-8 overflow-hidden">
          <motion.div
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 2.5, ease: "easeInOut" }}
            className="h-full bg-gradient-to-r from-[#5a6f3e] via-[#d4af37] to-[#5a6f3e]"
          />
        </motion.div>
      </div>
    </motion.div>
  );
}
